const translations = {
  title: 'Nova Atividade',
  title_edit: 'Editando Atividade',
  title_reopening: 'Reabrindo Atividade',
  bulkRegistration: 'Cadastro em massa',
  name: 'Nome',
  checklist: 'Questionário*',
  placeType: 'Tipo do destino',
  place: 'Destino*',
  asset: 'Ativo',
  responsible: 'Responsável',
  address: 'Endereço',
  scheduling: 'Data de agendamento',
  priority: 'Prioridade',
  tag: 'Tag',
  lockReasons: 'Motivos de bloqueio',
  additionalFields: 'Campos adicionais',
  description: 'Descrição',
  addFile: 'Adicionar Arquivo'
}

export default translations
